import React, { useId } from 'react'

// components
import TextArea from '../../atoms/TextArea/TextArea'
import FormItem from '../../atoms/FormItem/FormItem'

// types
import { TextAreaFormFieldProps } from './types'

// component
const TextAreaFormField = (props: TextAreaFormFieldProps) => {
	const {
		input: { value, onChange, onBlur, onFocus },
		meta: { error, invalid },
		label,
		htmlFor,
		required,
		labelScreenReaderOnly,
		id,
		...restProps
	} = props

	const generatedId = useId()
	const textAreaId = id ?? htmlFor ?? (label ? generatedId : undefined)
	const invalidStatus = !!(error || invalid)

	return (
		<FormItem
			htmlFor={textAreaId}
			label={label}
			labelScreenReaderOnly={labelScreenReaderOnly}
			required={required}
			error={invalidStatus && error ? error : undefined}
		>
			<TextArea
				id={textAreaId}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				onFocus={onFocus}
				invalid={invalid}
				{...restProps}
			/>
		</FormItem>
	)
}

export default TextAreaFormField
